export default __webpack_public_path__ + "static/media/GLOTrackGrey.309c4f96.svg";